import { render, staticRenderFns } from "./MenuLangSwitcher.vue?vue&type=template&id=b95f9378&"
import script from "./MenuLangSwitcher.vue?vue&type=script&lang=js&"
export * from "./MenuLangSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./MenuLangSwitcher.vue?vue&type=style&index=0&id=b95f9378&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports